import { LabWorkbookStatus } from '@resistapp/common/types';

export function shouldRequirePrimerStorageForAssignment(
  status: LabWorkbookStatus | null | undefined,
  isPrimerPrepReadOnly: boolean,
): boolean {
  if (isPrimerPrepReadOnly) {
    return false;
  }

  return status === LabWorkbookStatus.SUBMITTED || status === LabWorkbookStatus.MEASURED;
}
